<template>
	<div class="explanation-container">
		<transition name="explanation" mode="out-in">
			<div v-if="activeExplanation" 
				:key="activeExplanation.id" 
				class="explanation-item"
				:class="activeExplanation.status">
				<v-icon :icon="iconName" />
				<span v-html="activeExplanation.text"></span>
			</div>
		</transition>
	</div>
</template>

<script>
export default {
	name: 'AtomExplanation',
	props: {
		explanations: {
			type: Array,
			required: true,
			validator(value) {
				const allowed = ['error', 'warning', 'info']
				return value.every(
					(e) =>
						e &&
						Object.prototype.hasOwnProperty.call(e, 'status') &&
						allowed.includes(e.status) &&
						Object.prototype.hasOwnProperty.call(e, 'text')
				)
			},
		},
		current: {
			type: [String, Number],
			default: null,
		},
	},
	computed: {
		activeExplanation() {
			return (
				this.explanations.find((e) => e.id === this.current) || null
			)
		},
		iconName() {
			if (!this.activeExplanation) return ''
			const map = {
				error: 'fa-solid fa-triangle-exclamation',
				warning: 'fa-solid fa-triangle-exclamation',
				info: 'fa-solid fa-circle-info',
			}
			return map[this.activeExplanation.status] || 'fa-solid fa-circle-info'
		},
	},
}
</script>

<style scoped>
.explanation-container {
	min-height: 1.2em;
}

.explanation-enter-active,
.explanation-leave-active {
	transition: opacity 0.2s ease, transform 0.2s ease;
}

.explanation-enter-from,
.explanation-leave-to {
	opacity: 0;
	transform: translateY(10px);
}

.explanation-enter-to,
.explanation-leave-from {
	opacity: 1;
	transform: translateY(0);
}

.explanation-item {
	display: flex;
	align-items: center;
	gap: 0.3rem;
	text-align: left;
}

.explanation-item .v-icon {
	font-size: 1.0rem;
}

.explanation-item span {
	font-size: 1.2rem;
	display: inline-block;
	overflow: hidden;
	white-space: nowrap;
	text-overflow: ellipsis;
}

.explanation-item.error {
	color: rgb(var(--v-theme-error));
}

.explanation-item.warning {
	color: rgb(var(--v-theme-error));
}

.explanation-item.info {
	color: rgb(var(--v-theme-secondary));
}

@media (max-width: 500px) {
	.explanation-item .v-icon {
		font-size: 0.8rem;
	}

	.explanation-item span {
		font-size: 1rem;
	}
}

@media (max-width: 400px) {
	.explanation-item .v-icon {
		font-size: 0.7rem;
	}

	.explanation-item span {
		font-size: 0.9rem;
	}
}
</style>